module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top_text"
  }, [_c('v-icon', [_vm._v("beenhere")]), _vm._v("소재별 그룹별 리포트")], 1), _vm._v(" "), _c('div', {
    staticClass: "topTableWrap"
  }, [_c('CgTable', {
    attrs: {
      "viewData": _vm.viewData,
      "isExcel": _vm.isExcel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3489cc45","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign/creativeGroup/CgImp.vue
// module id = 839
// module chunks = 1